import { useHistory } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { createAgent, setNewAgentModal, getAllTemplateAgents } from '../../store/Agent';
import { getWorkspacePath } from '../../utils/workspaceUtils';

const AddAgentModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { newAgentModal, allTemplateAgents } = useSelector(state => state['Agent']);
  const { currentWorkspace } = useSelector(state => state['Settings']);
  
  const [agentData, setAgentData] = useState({ name: '' });

  useEffect(() => { if(newAgentModal) dispatch(getAllTemplateAgents()) }, [newAgentModal]);
  
  const toggleNewAgentModal = () => dispatch(setNewAgentModal(!newAgentModal));
  const onAgentUpdate = (e) => setAgentData({ ...agentData, [e['target']['name']]: e['target']['value'] });

  const handleCreateAgent = () => {
    dispatch(createAgent({ 
      data: agentData, 
      successCallback: (newAgent) => {
        setAgentData({ name: '' });
        dispatch(setNewAgentModal(false));
        if(newAgent['_id']) history.push(getWorkspacePath(`/agents/${newAgent['_id']}`, currentWorkspace?._id));
      }
    }));
  };

  return (
    <Modal isOpen={newAgentModal} toggle={toggleNewAgentModal} className={`main-modal new-user-modal modal-dialog-centered select-tampltes-modal`}>
      <ModalHeader toggle={toggleNewAgentModal}></ModalHeader>
      <ModalBody>
        <div className='add-content'>
          <h2>Select Template</h2>
          <div className='templates-inner'>
            <div className='account-tabs'>
              <div className='searchbox'>
                <label>Agent Name</label>
                <TextField 
                  fullWidth 
                  hiddenLabel 
                  name='name' 
                  size='small' 
                  variant='standard' 
                  placeholder='Agent Name' 
                  value={agentData['name']} 
                  onChange={onAgentUpdate} 
                />
              </div>
              <div className='account-tab-inner'>
                <div className='right-tabs-area full-width'>
                  <div className='tabs-content'>
                    <div className='template-tabs'>
                      <div className='template-inner'>
                        <div className={`template-box style-full`} onClick={() => setAgentData({ name: 'Blank Agent' })}>
                          <button className='btn-add'>
                            <div className='icon-area'>
                              <i>
                                <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M29.5 12.292V46.7087" stroke="#4b5563" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M12.2917 29.5H46.7083" stroke="#4b5563" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                              </i>
                              <h5>Start from blank</h5>
                            </div>
                            <div className='text-box'>
                              <p>A blank agent with no pre-defined script.</p>
                            </div>
                          </button>
                        </div>

                        {allTemplateAgents.map(item => {
                          return (
                            <div key={item['_id']} className={`template-box ${agentData['_id'] === item['_id'] ? 'active' : ''}`} onClick={() => setAgentData({ _id: item['_id'], name: item['name'] })}>
                              <button className='btn-add'>
                                <div className='icon-area'>
                                  <i dangerouslySetInnerHTML={{ __html: item['icon'] }} />
                                  <h5>{item['name']}</h5>
                                </div>
                                <div className='text-box'>
                                  <p>{item['boxBottomText']}</p>
                                </div>
                              </button>
                            </div>
                          );
                        })}
                        
                        <div className='btn-box'>
                          <button className='btn-style-border' onClick={toggleNewAgentModal}>Close</button>
                          <button className='btn-style-new' onClick={handleCreateAgent}>Create Agent</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddAgentModal;